import { StorefrontProductImageGallery } from '@emporion/ui'

type Props = {
  activeProductImage: string
  productGallery: string[]
  productName: string
  onSelectProductImage: (imageUrl: string) => void
  onOpenZoom: () => void
}

export const ProductImageGallery = ({
  activeProductImage,
  productGallery,
  productName,
  onSelectProductImage,
  onOpenZoom,
}: Props) => (
  <StorefrontProductImageGallery
    activeProductImage={activeProductImage}
    productGallery={productGallery}
    productName={productName}
    onSelectProductImage={onSelectProductImage}
    onOpenZoom={onOpenZoom}
  />
)
